import { CHANGE_NETWORK_STATUS } from 'actions/networkStatusActions';

const INITIAL_STATE = 'ONLINE';

export default function networkStatus(state = INITIAL_STATE, action = null) {
	switch (action.type) {
		case CHANGE_NETWORK_STATUS:
			return action.networkStatus || INITIAL_STATE;
		default:
			return state;
	}
}
